import { apiGet } from '@/store/api';
import { useHelperStore } from '@/store/helperStore';

export async function getConsentTypes() {
  const data = await apiGet('helper/consentTypes');

  useHelperStore().setConsentTypes(data);
}
